import { render } from "./JournalReport.vue?vue&type=template&id=1d9f0fb0&scoped=true"
import script from "./JournalReport.vue?vue&type=script&lang=js"
export * from "./JournalReport.vue?vue&type=script&lang=js"

import "./JournalReport.vue?vue&type=style&index=0&id=1d9f0fb0&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9f0fb0"]])

export default __exports__